module.exports = __webpack_public_path__ + "static/img/logo.7823aca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = dLd/
// module chunks = 3